import type { SVGProps } from 'react';

import * as MintIcons from '@mint-lib/icons';
import type { IconsList } from '@mint-lib/icons/allIcons';
import { cn } from '@mint-lib/tw-utils';

export type IconProps = SVGProps<SVGSVGElement> & {
  component: IconsList;
};

export const Icon = ({ component, className, ...props }: IconProps) => {
  const IconComponent = MintIcons[component];

  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      className={cn('size-4 fill-icon-primary', className)}
      {...props}
    />
  );
};
